<template>
  <div class="jissueview">
    <b-card>
      <b-card v-for="cite in issue_details" :key="cite.id" class="secondary m-3">
        <b-row>
        <b-col cols="10" class="text-left text-secondary">
          <h5 class="text-left" variant="secondary">
            {{ `${journal_abbr} (${year}) ${voliss}, ${cite.pages}` }}
          </h5>
          <h6 class="text-left">{{ cite.title }}</h6>
          <p class="text-left">{{ cite.author }}</p>
          <a :href="`https://dx.doi.org/${cite.doi}`" target="_blank" >
            DOI:{{cite.doi}}
          </a>
        </b-col>
        <b-col cols="2">
          <b-list-group>
            <b-list-group-item variant="info">
              <a :href="`/ThermoML/${cite.doi}.html`" target="_blank">
                Details
              </a>
            </b-list-group-item>
            <b-list-group-item>
              <a :href="`/ThermoML/${cite.doi}.json`" target="_blank"> JSON </a>
            </b-list-group-item>
            <b-list-group-item>
              <a :href="`/ThermoML/${cite.doi}.xml`" target="_blank">
                ThermoML</a
              >
            </b-list-group-item>
          </b-list-group>
        </b-col>
        </b-row>
      </b-card>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "TMLJIssue",
  props: {
    issue_details: Array,
    journal_abbr: String,
    year: String,
    voliss: String,
  },
  data() {
    return {
      fields: [
        { key: "title" },
        { key: "pages" },
        { key: "author" },
        { key: "doi" },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
